<div class="w-100 centvh">
        <button mat-icon-button class="close-button" (click)="close()">
                <mat-icon>close</mat-icon>
        </button>
        <div class="w-100 centvh p-2">
                <span class="mat-h3 nomarg">Navigate to the marked location</span>
        </div>
        <a class="nolnk w-100 center" target="_blank" href="https://www.google.com/maps/search/?api=1&query={{location.lat}},{{location.lon}}">
        <button class="w-100" mat-raised-button color="primary">Navigate</button>
        </a>
</div>